import styled, { css } from 'styled-components';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
var activeStyles = css(["background-color:", ";color:#fff;"], function (_ref) {
  var theme = _ref.theme,
    secondary = _ref.secondary;
  return secondary ? theme.secondaryButtonColor : theme.buttonColor;
});
var disabledStyles = css(["background-color:", ";color:#fff;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui;
});
export var Handler = styled(ButtonLined).withConfig({
  displayName: "Handler",
  componentId: "sc-5ksrgy-0"
})(["height:38px;padding-left:20px;padding-right:20px;border:2px solid ", ";margin-right:10px;font-size:14px;font-weight:500;", " ", ""], function (_ref3) {
  var theme = _ref3.theme,
    secondary = _ref3.secondary;
  return secondary ? theme.secondaryButtonColor : theme.buttonColor;
}, function (_ref4) {
  var active = _ref4.active;
  return active && activeStyles;
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && disabledStyles;
});